export default  {
    state:{
        inpatinfoInput:{
        },
        inpatinfoOutput:{

        },
        inPrePayByTInput:{

        },
        inPrePayByTOutput:{

        }

    },
    actions: {
        changeInpatinfoInput:(context,para)=>{
            context.commit('changeInpatinfoInput',para)
        },

        changeInpatinfoOutput:(context,para)=>{
            context.commit('changeInpatinfoOutput',para)
        },

        changeInPrePayByTInput:(context,para)=>{
            context.commit('changeInPrePayByTInput',para)
        },

        changeInPrePayByTOutput:(context,para)=>{
            context.commit('changeInPrePayByTOutput',para)
        },

        clearInPayment:(context)=>{
            context.commit('clearInPayment')
        }
    },
    mutations: {
        changeInpatinfoInput:(state,para)=>{
            state.inpatinfoInput =   para  
        },

        changeInpatinfoOutput:(state,para)=>{
            state.inpatinfoOutput =   para  
        },

        changeInPrePayByTInput:(state,para)=>{
            state.inPrePayByTInput =   para  
        },

        changeInPrePayByTOutput:(state,para)=>{
            state.inPrePayByTOutput =   para  
        },

        
        clearInPayment:(state)=>{
            state.inpatinfoInput =   {}  
            state.inpatinfoOutput =   {}  
            state.inPrePayByTInput =   {}  
            state.inPrePayByTOutput =   {}  
        }
    }
}